/* eslint react-refresh/only-export-components: 0 */
import { createContext, useContext } from "react";

const MenuOpenContext = createContext(false);

export const MenuOpenProvider = MenuOpenContext.Provider;

/** Whether the enclosing MDS `Menu` is open. */
export function useMenuOpen(): boolean {
  return useContext(MenuOpenContext);
}
